import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { StudioService } from '../../core/services/studio.service';
import { FlashService } from '../../core/services/flash.service';

@Component({
    selector: 'app-studio-plan-new',
    imports: [RouterLink, FormsModule],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-edit"></i>&nbsp;区分コース 新規作成</span>
        </div>
        <div class="card-body">
          <div style="height: 1px"></div>
          <div class="col-md-12">
            <div class="form-group row">
              <div class="col-md-6">
                <table class="table-bordered table-sm">
                  <thead>
                    <tr><th width="50%">表示ID</th><th width="50%">店舗名</th></tr>
                  </thead>
                  <tbody>
                    <tr><td>{{studio.sortBy}}</td><td>{{studio.name}}</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <form novalidate name="studioPlanCreateForm" #studioPlanCreateForm="ngForm" (ngSubmit)="save()">
            <div class="col-md-12">
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">コース名</label>
                  <input type="text" class="form-control" [(ngModel)]="form.name" name="name" required maxlength="200">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">コースタイプ</label>
                  <select class="form-control" [(ngModel)]="form.studioPlanTypeId" name="studioPlanTypeId">
                    <option value="">-- なし --</option>
                    @for (t of planTypes; track t.id) {
                      <option [value]="t.id">{{t.name}}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-4">
                  <label class="col-form-label">利用時間</label>
                  <select class="form-control" [(ngModel)]="form.time" name="time" required>
                    <option value="">-- 選択してください --</option>
                    <option value="24">24時間</option>
                    <option value="0">その他</option>
                  </select>
                </div>
                @if (form.time == '0') {
                  <div class="form-group col-md-4">
                    <label class="col-form-label">時間を選択してください</label>
                    <div class="bisected-input-wrap">
                      <div class="bisected-input">
                        <select class="form-control" [(ngModel)]="form.time_start" name="time_start" required>
                          @if (form.time_start == null) { <option [ngValue]="null"></option> }
                          @for (t of timeOptions; track t.id) {
                            <option [ngValue]="t.id">{{t.name}}</option>
                          }
                        </select>
                      </div>
                      <span>&nbsp;~&nbsp;</span>
                      <div class="bisected-input">
                        <select class="form-control" [(ngModel)]="form.time_end" name="time_end" required>
                          @if (form.time_end == null) { <option [ngValue]="null"></option> }
                          @for (t of timeOptions; track t.id) {
                            <option [ngValue]="t.id">{{t.name}}</option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">月会費（初月）</label>
                  <select class="form-control" [(ngModel)]="form.firstMonthProductId" name="firstMonthProductId" required>
                    <option value="">-- 選択してください --</option>
                    @for (p of products1; track p.id) {
                      <option [value]="p.id">{{productLabel(p)}}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">月会費（2ヶ月目）</label>
                  <select class="form-control" [(ngModel)]="form.secondMonthProductId" name="secondMonthProductId" required>
                    <option value="">-- 選択してください --</option>
                    @for (p of products1; track p.id) {
                      <option [value]="p.id">{{productLabel(p)}}</option>
                    }
                  </select>
                </div>
              </div>
              <div>
                <label class="col-form-label">月会費（3~12ヶ月目）</label>
                <a href="" class="btn btn-success" [class.disabled]="sortLength > 9" (click)="pushIndividuals(); $event.preventDefault()"><i class="fa fa-plus-circle"></i></a>
                <a href="" class="btn btn-success" [class.disabled]="sortLength < 1" (click)="popIndividuals(); $event.preventDefault()"><i class="fa fa-minus-circle"></i></a>
              </div>
              @for (item of visibleIndividuals(); track $index) {
                <div class="form-group row">
                  <div class="col-md-6">
                    <label class="col-form-label">{{$index + 3}}ヶ月目</label>
                    <select class="form-control" [(ngModel)]="item.productId" [name]="'ind_' + $index" required>
                      <option value="">-- 選択してください --</option>
                      @for (p of products1; track p.id) {
                        <option [value]="p.id">{{productLabel(p)}}</option>
                      }
                    </select>
                  </div>
                </div>
              }
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">月会費（通常）</label>
                  <select class="form-control" [(ngModel)]="form.monthlyProductId" name="monthlyProductId" required>
                    <option value="">-- 選択してください --</option>
                    @for (p of products1; track p.id) {
                      <option [value]="p.id">{{productLabel(p)}}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">入会金・事務手数料</label>
                  <select class="form-control" [(ngModel)]="form.studioKeyProductId" name="studioKeyProductId" required>
                    <option value="">-- 選択してください --</option>
                    @for (p of products2; track p.id) {
                      <option [value]="p.id">{{productLabel(p)}}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12 text-right">
                  <a [routerLink]="['/studio', studioId, 'plan']" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
                  <button type="submit" class="btn btn-success" [disabled]="saving || studioPlanCreateForm.invalid"><i class="fa s-icon-save"></i>&nbsp;保存</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
  `
})
export class StudioPlanNewComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private studioService = inject(StudioService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private flash = inject(FlashService);

  studioId!: number;
  studio: any = {};
  form: any = {
    studioPlanIndividuals: [], time: '', time_start: null, time_end: null,
    studioPlanTypeId: '', firstMonthProductId: '', secondMonthProductId: '',
    monthlyProductId: '', studioKeyProductId: '',
  };
  products: any[] = [];
  planTypes: any[] = [];
  sortLength = 0;
  saving = false;

  readonly timeOptions = Array.from({ length: 24 }, (_, i) => ({
    id: i,
    name: String(i).padStart(2, '0') + ':00',
  }));

  get products1() { return this.products.filter(p => p.productType === 1); }
  get products2() { return this.products.filter(p => p.productType === 2); }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('店舗管理', 's-icon-studio');
    this.studioId = +this.route.snapshot.params['studioId'];
    const [studio, planTypes, productData]: any[] = await Promise.all([
      this.studioService.list(this.studioId),
      this.studioService.getPlanType(),
      this.studioService.getProduct(this.studioId),
    ]);
    this.studio = studio;
    this.planTypes = Array.isArray(planTypes) ? planTypes : [];
    this.products = (Array.isArray(productData) ? productData : []).filter((p: any) => p.status === 0);
  }

  productLabel(p: any): string {
    const price = Math.floor(p.amount * (1 + Number(p.taxRate?.rate ?? 0)));
    return `(¥${price.toLocaleString()}) ${p.name}`;
  }

  visibleIndividuals(): any[] {
    return this.form.studioPlanIndividuals.filter((v: any) => v.sortBy <= this.sortLength);
  }

  pushIndividuals(): void {
    if (this.sortLength >= 10) return;
    if (this.sortLength >= this.form.studioPlanIndividuals.length) {
      this.form.studioPlanIndividuals.push({
        studioPlanId: this.form.id,
        productId: '',
        sortBy: this.form.studioPlanIndividuals.length + 1,
      });
    }
    this.sortLength += 1;
  }

  popIndividuals(): void {
    if (this.sortLength > 0) this.sortLength--;
  }

  async save(): Promise<void> {
    if (!this.form.name) return;
    this.saving = true;
    try {
      const json = { ...this.form };
      const findProduct = (id: any) => this.products.find(p => p.id == id);
      json.firstMonthFee = findProduct(json.firstMonthProductId)?.amount;
      json.secondMonthFee = findProduct(json.secondMonthProductId)?.amount;
      json.monthlyFee = findProduct(json.monthlyProductId)?.amount;
      if (json.time === '24') {
        json.time = '24時間';
      } else {
        const pad = (n: number) => String(n).padStart(2, '0') + ':00';
        json.time = `${pad(json.time_start)}〜${pad(json.time_end)}`;
      }
      delete json.time_start;
      delete json.time_end;
      json.studioPlanIndividuals = this.form.studioPlanIndividuals.filter((v: any) => v.sortBy <= this.sortLength);
      json.studioId = this.studioId;
      const saved: any = await this.studioService.upsertStudioPlan(json);
      if (saved?.id) {
        // 旧版 studio.js:767-770: Flash 後に区分コース編集画面へ遷移（表示は studioPlan-edit の <flash-message>）
        this.flash.create('success', '区分コースを新規作成しました');
        await this.router.navigate(['/studio', this.studioId, 'plan', saved.id, 'edit']);
      }
    } finally {
      this.saving = false;
    }
  }
}
